import React, {Component} from 'react';
import {connect} from 'react-redux';
import {API_URL, IMAGE_URL} from "../../config/Config";
import axios from "axios/index";
import {Row, Col, Alert, Button, FormGroup, Label, Input, FormText} from "reactstrap";
import { ToastContainer, toast } from 'react-toastify';
import PageLoader from "../loader/PageLoader";
import {setUser} from "../../redux/actions/user";

import SaveLoader from "./../loader/SaveLoader";
import axiosRetry from 'axios-retry';
axiosRetry(axios, { retries: 3 });

class ChangeAvatar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loading1: false,
            file: '',
            imagePreviewUrl: '',
            errors: {},
            hasAlert:false,
        };

    }

    handleChange(event) {
        event.preventDefault();
        let reader = new FileReader();
        let file = event.target.files[0];
        reader.onloadend = () => {
            this.setState({
                file: file,
                imagePreviewUrl: reader.result
            });
        };
        reader.readAsDataURL(file);

    }

    checkStatus(response) {
        if (response.status < 200 || response.status > 300) {
            const error = new Error(response.statusText);
            error.response = response;
            throw error;
        }
        return response.data;
    }

    handleSubmit(event) {
        event.preventDefault();
        const formData = new FormData();
        formData.append('pic', this.state.file);
        let errors = {};
        this.setState({loading1:true});
        axios.post(`${API_URL}user-upload-pic?api_token=${this.props.user.apiToken}`, formData)
            .then(
                this.checkStatus
            ).then(json => {
            this.props.setUser(json.data);
            toast.success("تصویر با موفقیت بارگذاری شد.",{
                autoClose: 3000,
                position: toast.POSITION.TOP_RIGHT,
                rtl:true
            });
            this.setState({loading1:false,hasAlert:false});
        })
            .catch(error => {
                this.setState({loading:true});
                const response = error.response;
                if (response === undefined) {
                    toast.error("خطایی در هنگام بارگذاری تصویر رخ داد.",{
                        autoClose: 3000,
                        position: toast.POSITION.TOP_RIGHT,
                        rtl:true
                    });
                    console.log(error);
                } else {
                    console.log(response.data);
                    toast.error(response.data.data,{
                        autoClose: 3000,
                        position: toast.POSITION.TOP_RIGHT,
                        rtl:true
                    });
                }

                this.setState({hasAlert:true, errors,loading1:false});
            });
    }

    render() {
        let {imagePreviewUrl} = this.state;
        let imagePreview = null;
        const user =  this.props.user;

        if (imagePreviewUrl) {
            imagePreview = (<img src={imagePreviewUrl} alt={`${user.firstName} ${user.lastName}`}/>);
        } else {
            imagePreview = (<img src={IMAGE_URL+this.props.user.pic} alt={`${user.firstName} ${user.lastName}`} />);
        }
        const {errors, loading} = this.state;


        return (
            <div className="pt-3">
                <Row>
                    <Col md="12">
                        {this.state.hasAlert?
                            <Alert color="danger">
                                خطایی در هنگام ثبت اطلاعات رخ داد.
                            </Alert>
                            :""}
                    </Col>
                </Row>
                {!loading ? <PageLoader type="bubbles" color="#4fbfa8"/>:
                    <form onSubmit={(e)=>this.handleSubmit(e)} >
                        <Row>

                            <Col md="6" sm="12">
                                <div className="imgPreview">
                                    {imagePreview}
                                </div>
                            </Col>
                            <Col md="6" sm="12">
                                <FormGroup>
                                    <Label for="exampleFile">تصویر کاربر</Label>
                                    <Input
                                        type="file"
                                        className={errors["file"]?"form-control is-invalid":"form-control"}
                                        placeholder="تصویر کاربر"
                                        name="file"
                                        onChange={this.handleChange.bind(this)}
                                    />
                                     {errors["file"]?<div className="invalid-feedback" >{errors["file"]}</div>:""}
                                    <FormText color="muted">
                                        فرمت مجاز jpg، png و gif  و حجم کمتر از 1024 کیلوبایت می باشد.
                                    </FormText>
                                </FormGroup>
                                <div className="text-center mt-5">
                                    <Button color="default" block onClick={this.handleSubmit.bind(this)} className="mb-4 mt-4">
                                        ثبت<i className="fa fa-paper-plane-o white-text ml-1"></i>
                                    </Button>
                                </div>

                            </Col>
                        </Row>
                    </form>}
                {this.state.loading1 ? <SaveLoader type='spinningBubbles' color='#fff' height={document.body.clientHeight}/>:""}

                <ToastContainer
                    hideProgressBar={true}
                    newestOnTop={true}
                    autoClose={5000}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
};
const mapDispatchToProps = dispatch => {
    return {
        setUser : user => {
            dispatch(setUser(user))
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(ChangeAvatar);



// WEBPACK FOOTER //
// ./src/components/user/ChangeAvatar.js